module.exports = __webpack_public_path__ + "static/jurek.6f6b4d86.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jurek.webp
// module id = 317
// module chunks = 263791100135453